import React from "react";
import "./USP.css";
import USPSection2 from "../../components/USPSection2/USPSection2";

// Main component for Our USP
export default function USP() {
  return (
    <>
      {/* Section displaying our USP */}
      <USPSection2 />
    </>
  );
}
